<template>
    <div class="gsap-slider-line absolute -bottom-8 left-2 flex space-x-4">
        <div v-for="item in state.slidesNum" :key="item" class="h-1 w-10 cursor-pointer bg-[#adadad]" :class="{ '!bg-[#000]': state.currentIndex === item - 1 }" @click="setCurrentIndex(item - 1)"></div>
    </div>
</template>

<script setup lang="ts">
import { SliderSymbol } from "./slider.const";

let sliderProvide = inject<any>(SliderSymbol);
if (!sliderProvide) throw new Error("sliderProvide");
const {
    state,
    methods: { setCurrentIndex },
} = sliderProvide;
</script>
